export default __webpack_public_path__ + "static/media/Home_two.c50be548.png";